export enum UserTransfersLoaders {
    isUserTransfersLoading,
    isMoneyTransfersToMyselfLoading
}